import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Divider from 'vux/src/components/divider/index.vue'

import CryptoJS from "crypto-js";
import { mapActions, } from 'vuex'
export default {
name: 'login',

components: {
Tab,
TabItem,
Swiper,
SwiperItem,
XInput,
Group,
CheckIcon,
XButton,
Toast,
Divider
},
data() {
return {
isShuPing: true,
loginMethods: 'phone',
index: 0,
phoneReg: /^1[3456789]\d{9}$/,  //手机号正则
rememberPsd: true,    //记住密码
togglePassword: 'password', //密码输入框的类型
togglePsdIcon: require('../../assets/images/showPsd.png'),  //切换显示密码、隐藏密码的icon路径
timerText: '获取验证码',
isDisabled: false,  //获取验证码按钮的 disabled
disabledActive: false,  //获取验证码后倒计时的样式
maskValue: '',  //手机号码双向绑定
maskValue2: '', //验证码双向绑定
maskValue3: '', //账号双向绑定
maskValue4: '', //密码双向绑定
isVouchers:false,
desUtil: {

_key: "F9387E75D65343CA87103DE403D7CDBFB7F0163776164FEC956406DB2DBD401D",

_type: 1,

encrypt: function (message) {
var key = this._key;
var keyHex = CryptoJS.enc.Utf8.parse(key);
var encrypted = CryptoJS.DES.encrypt(message, keyHex, {
mode: CryptoJS.mode.ECB,
padding: CryptoJS.pad.Pkcs7
});
var result = "";
switch (this._type.toString()) {
case "1":

result = encrypted.ciphertext.toString(CryptoJS.enc.Hex);
console.log(result);

break;
}
return result;
}
},

callBack: '',

}
},

methods: {
...mapActions ([
'actionsUserData'
]),
getCodeFun() {   //获取验证码的函数
this.$request.post('/message/verificationCode', {
phone: this.maskValue.replace(/\ +/g, "")
}).then(data => {
console.log(data)
}).catch(e => {
console.log(e)
})
},
back() {
this.$router.go(-1)
},
accountMethodLogin() {
this.loginMethods = 'account'
},
phoneMethodLogin() {
this.loginMethods = 'phone'
},
phoneLoginFun(data) {   //手机登录函数

this.$vux.loading.show({
text: '登录中...'
})
this.$request.post('/user/loginByPhone', data).then(data => {
if (data.code == 0) {   //登录成功
sessionStorage.setItem('salesmanCode','')
this.$vux.loading.hide()
this.$vux.toast.show({
type: 'success',
text: data.msg,
time: 600
})
let vPath = this.$route.query.fullPath
this.setCookie('_token', data.obj.token, 0.288)

this.setCookie('_userImg', data.obj.imagePath?data.obj.imagePath:'https://hlh-shopping.oss-cn-shenzhen.aliyuncs.com/quotation/2020/1120/yY8FkQTZMf.png', 0.288)
this.$store.dispatch('actionsUserData',data.obj)



if(data.obj.boolNewUser=='Y') {
this.getVoucher()
}else{
setTimeout(() => {
vPath ? this.$router.push({ path: vPath }) : this.$router.push({ path: '/' })
}, 650);
}


} else {    //否则
this.$vux.loading.hide()
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
this.$vux.loading.hide()
this.$vux.toast.show({
type: 'cancel',
text: e.msg
})
})
},
setCookie(cname, cvalue, exdays) {



var d = new Date();
d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
var expires = "expires=" + d.toUTCString();
document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/"   
console.log(d)
},
togglePsd() {  //切换显示、隐藏密码
if (this.togglePassword == 'password') {
this.togglePassword = 'text'
this.togglePsdIcon = require('../../assets/images/hidePsd.png')
} else {
this.togglePassword = 'password'
this.togglePsdIcon = require('../../assets/images/showPsd.png')
}
},
getCode() {  //获取验证码
let phoneText = this.maskValue.replace(/\ +/g, "");

if (phoneText == '') {
this.$vux.toast.show({
type: 'warn',
text: '手机号码为空'
})
return false;
} else {
if (!this.phoneReg.test(phoneText)) {
this.$vux.toast.show({
type: 'warn',
text: '手机号码有误'
})
return false;
} else {
this.getCodeFun()
this.isDisabled = true
this.disabledActive = true
let codeTimer = 60
let timeOutFn = setInterval(() => {
this.timerText = codeTimer-- + 's 后重新获取'
if (codeTimer == -1) {
clearInterval(timeOutFn)
this.timerText = '获取验证码'
this.isDisabled = false
this.disabledActive = false
}
}, 1000);
}
}
},
getProvince() {
var p = new Promise((resolve, reject) => {
var adddress = '',
province = '',
loadScript;
function loadJS(url) { //加载js
loadScript = document.createElement("script");
loadScript.type = "text/javascript";
loadScript.src = url;
document.body.appendChild(loadScript);
}
loadJS("https://pv.sohu.com/cityjson?ie=utf-8");
loadScript.onload = function () {

adddress = returnCitySN["cname"]


if (adddress.split('省').length != 1) {
province = adddress.split('省')[0] + '省'
} else if (adddress.split('区').length != 1) {
province = adddress.split('区')[0] + '区'
} else {
province = adddress.split('市')[0] + '市'
}
resolve(province)
}
})
return p
},
psdLogin() { //账号密码登录
let account = this.maskValue3.replace(/\ +/g, ""),
password = this.maskValue4.replace(/\ +/g, "");

if (account == '') {
this.$vux.toast.show({
type: 'warn',
text: '账号为空'
})
return false;
}
if (password == '') {
this.$vux.toast.show({
type: 'warn',
text: '密码为空'
})
return false;
}

let _password = this.desUtil.encrypt(password);

this.getProvince().then((province) => {
this.$vux.loading.show({
text: '登录中...'
})

this.$request.post('/user/login', {
name: account,
password: _password,
province,
salesmanCode:sessionStorage.getItem('salesmanCode')
}).then(data => {
if (data.code == 0) {   //登录成功
sessionStorage.setItem('salesmanCode','')
this.$vux.loading.hide()
this.$vux.toast.show({
type: 'success',
text: data.msg,
time: 600
})

let vPath = this.$route.query.fullPath
this.setCookie('_token', data.obj.token, 0.288);
this.setCookie('_isMonthlyKnots', data.obj.monthlyKnots, 0.288);
this.setCookie('_userImg', data.obj.imagePath?data.obj.imagePath:'https://hlh-shopping.oss-cn-shenzhen.aliyuncs.com/quotation/2020/1120/yY8FkQTZMf.png', 0.288)
this.$store.dispatch('actionsUserData',data.obj)

this.$token = data.obj.token
this.$emit("loginCallback", false, data);
setTimeout(() => {
vPath ? this.$router.push({ path: vPath }) : this.$router.push({ path: '/' })



}, 650);
} else {    //否则
this.$vux.loading.hide()
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
this.$vux.loading.hide()
this.$vux.toast.show({
type: 'cancel',
text: e
})
})
})

},
phoneLogin() { //手机登录

let phoneText = this.maskValue.replace(/\ +/g, ""),
code = this.maskValue2.replace(/\ +/g, "");
if (phoneText == '') {
this.$vux.toast.show({
type: 'warn',
text: '手机号码为空'
})
return false;
} else if (!this.phoneReg.test(phoneText)) {
this.$vux.toast.show({
type: 'warn',
text: '手机号码有误'
})
return false;
}
if (code == '') {
this.$vux.toast.show({
type: 'warn',
text: '验证码为空'
})
return false;
}

this.getProvince().then((province) => {
let datas = {
phone: phoneText,
verificationCode: code,
province,
invitationCode : this.$common.getCookie('_mobileInviteCode')?this.$common.getCookie('_mobileInviteCode'):'',
salesmanCode:sessionStorage.getItem('salesmanCode')
}

this.phoneLoginFun(datas)



















})


},

qqLoginClick() {




if (typeof localStorage === 'object') {
try {
localStorage.setItem('localStorage', 1);
localStorage.removeItem('localStorage');
} catch (e) {
Storage.prototype._setItem = Storage.prototype.setItem;
Storage.prototype.setItem = function() {};
alert('您处于无痕浏览，无法为您登录');
return false;
}
}

let myUrl = encodeURIComponent('https://www.qsy3d.com/mobileLogin/mobileLogin.html'),
backUrl = encodeURIComponent(location.origin+'/#/loginTransfers?type=login');


location.href = 'https://graph.qq.com/oauth2.0/authorize?response_type=token&client_id=101811587&redirect_uri='+myUrl+'&state='+backUrl
},
getVoucher(){
this.$request.post('/couponDetail/getNewPeopleCoupon',{

},).then(data => {
if(data.code ==0) {









this.isVouchers = true


}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
this.$router.push({ path: '/' })

}

})
},
close(){
if(sessionStorage.getItem('page')=='1'){




this.$router.push({
path: '/'
})
}else{
this.$router.push({
path: '/'
})
}

},
use(){
this.$router.push({
path: '/print'
})
}
},
created() {















},
mounted() {
let that = this
if (window.orientation === 180 || window.orientation === 0) {

that.isShuPing = true
}
if (window.orientation === 90 || window.orientation === -90) {

that.isShuPing = false
}
window.addEventListener("onorientationchange" in window ? "orientationchange" : "resize", function () {
if (window.orientation === 180 || window.orientation === 0) {

that.isShuPing = true
}
if (window.orientation === 90 || window.orientation === -90) {

that.isShuPing = false
}
}, false);

console.log( window.location.href);











},
}



// WEBPACK FOOTER //
// ./src/views/login/script.js